var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee5050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.47 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.241,21.759a7.652,7.652,0,0,1,0-10.822L5.531,7.648,7.652,9.769,4.363,13.058a4.652,4.652,0,0,0,6.579,6.579l3.288-3.289,2.121,2.121-3.289,3.289a7.65,7.65,0,0,1-10.82,0Zm5.2-5.2a1.5,1.5,0,0,1,0-2.121l7-7a1.5,1.5,0,1,1,2.121,2.121l-7,7a1.5,1.5,0,0,1-2.121,0Zm8.91-2.333,3.289-3.289a4.652,4.652,0,0,0-6.579-6.579L9.774,7.648,7.652,5.526l3.289-3.289a7.652,7.652,0,0,1,10.82,10.822l-3.289,3.289Z",
    transform: "translate(0.47 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.8b1cf4819a03906e96caaea160913f64.svg";
export { ForwardRef as ReactComponent };